export enum Errors {
  INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
  MALFORMED_CONTENT        = 'MALFORMED_CONTENT',
  CREDENTIALS_INVALID      = 'CREDENTIALS_INVALID',
  EMAIL_ALREADY_USED       = 'EMAIL_ALREADY_USED',
}

export enum LogLevel {
  INFO  = 'INFO',
  WARN  = 'WARN',
  ERROR = 'ERROR',
  LOG   = 'LOG',
}

export enum Permissions {
  ALLOW_ALL          = 'ALLOW_ALL',
  MANAGE_PERMISSIONS = 'MANAGE_PERMISSIONS',
  MANAGE_USERS       = 'MANAGE_USERS',
  MANAGE_PAGES       = 'MANAGE_PAGES',
  MANAGE_BLOCKS      = 'MANAGE_BLOCKS',
}

export enum ModalComponents {
  APPOINTMENT         = 'appointment-modal',
  REMOVE_APPOINTMENT  = 'remove-appointment-modal',
  ADD_SEAT            = 'add-seat-modal',
  ADD_ROOM            = 'add-room-modal',
  REMOVE_USER         = 'remove-user-modal',
  ADD_USER            = 'add-user-modal',
  NO_ROOMS            = 'no-rooms-modal',
  OVERRIDE_PREMIUM    = 'override-premium-modal',
  CANCEL_SUBSCRIPTION = 'cancel-subscription-modal',
  CHANGE_SUBSCRIPTION = 'change-subscription-modal',
  DELETE_COMPANY      = 'delete-company-modal'
}